import { Box } from "@mui/material";

export default function NotificationBadge({ notificationsCount }) {
  return (
    <Box
      className="notification-badge"
      sx={{
        top: 0,
        right: -1,
        backgroundColor: "red",
        color: "white",
        borderRadius: "50%",
        width: 20,
        height: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: "bold",
      }}
    >
      {notificationsCount > 9 ? "+9" : notificationsCount}
    </Box>
  );
}
